module.exports = __webpack_public_path__ + "img/cyl1.3d40c4ec.png";